module.exports = __webpack_public_path__ + "static/img/icon_客服.54d0d8a2.svg";